

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { CollectionVoucherSetup } from "../../components/CollectionVoucherSetup/CollectionVoucherSetup";


export const CollectionVoucherSetupPage = () => {
    return (
        <AuthenticatedLayout
            pageTitle="Collection Voucher Setup"
            pageTitleIcon={<DescriptionOutlinedIcon />}
            breadcrumbCurrentPageName=""
            // breadcrumbLinks={[
            //     { text: "", navigateTo: "/voucher/collection/setup" }
            // ]}
            mainContents={<CollectionVoucherSetup />}
        />
    );
};
